import { Control, Controller } from "react-hook-form";
import Select from "react-select";

export type OptionProps = {
  value: number;
  label: string;
};

export type SingleSelectProps = {
  options: OptionProps[];
  control: Control;
  defaultValue: number | [];
  isPending: boolean;
  name: string;
  label: string;
  onChange?: (value: number | undefined) => void;
  isClearable?: boolean;
};

export default function SingleSelect({
  options,
  defaultValue,
  isPending = true,
  control,
  name,
  label,
  onChange,
  isClearable = true,
}: SingleSelectProps) {
  return (
    <>
      {label != "" && (
        <label htmlFor={name} className="form-label text-uppercase fw-semibold">
          {label.toUpperCase()}
        </label>
      )}
      {isPending ? (
        <Select isLoading isDisabled />
      ) : (
        <Controller
          name={name}
          control={control}
          defaultValue={options.find(({ value }: { value: number }) => value === defaultValue) || null}
          render={({ field }) => (
            <Select
              {...field}
              // ref={ref}
              options={options}
              value={options.find(({ value: optionValue }: OptionProps) => optionValue === field.value) || null}
              // onChange={(selectedOption) => onChange(selectedOption ? selectedOption.value : null)}
              instanceId={name}
              isMulti={false}
              isClearable={isClearable}
              onChange={(newValue) => {
                field.onChange(newValue?.value);
                onChange?.(newValue?.value);
              }}
              styles={{
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  backgroundColor: state.isSelected ? "#5e73ac" : "white",
                  color: state.isSelected ? "white" : "black",
                  cursor: "pointer",
                }),
              }}
            />
          )}
        />
      )}
    </>
  );
}
